import { render, staticRenderFns } from "./claudeConfigDialog.vue?vue&type=template&id=364c2389&"
import script from "./claudeConfigDialog.vue?vue&type=script&lang=js&"
export * from "./claudeConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports